var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlfredBlackSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 68,
    viewBox: "0 0 143 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9901 16.823C5.79527 16.823 2.71189 17.6402 0.594387 19.2748L2.4147 22.6554C3.90066 21.4295 6.20391 20.6865 8.43286 20.6865C11.7391 20.6865 13.3737 22.2839 13.3737 24.9958V25.293H8.24712C2.22895 25.293 0 27.8934 0 31.1997C0 34.6546 2.86049 37.1436 7.39269 37.1436C10.3646 37.1436 12.5193 36.1777 13.6337 34.4688V36.8835H18.0174V25.2558C18.0174 19.5348 14.7111 16.823 8.9901 16.823ZM8.35857 33.763C5.98102 33.763 4.56935 32.6857 4.56935 31.0139C4.56935 29.5651 5.42378 28.3763 8.58146 28.3763H13.3737V30.6796C12.5936 32.7228 10.6247 33.763 8.35857 33.763Z",
    fill: "#111312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0713 36.8835H27.715V9.31882H23.0713V36.8835Z",
    fill: "#111312"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9655 12.8108C41.9314 12.8108 42.823 13.1452 43.5288 13.6281L44.8291 10.1361C43.7889 9.39312 42.2286 9.05878 40.6312 9.05878C36.0247 9.05878 33.5357 11.7707 33.5357 15.9314V17.1944H30.2666V20.9094H33.5357V36.8835H38.1794V20.9094H43.4917V17.1944H38.0308V16.0057C38.0308 13.8882 39.0338 12.8108 40.9655 12.8108Z",
    fill: "#111312"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1326 19.9435V17.0459H45.7119V36.8835H50.3555V27.2619C50.3555 23.2126 52.5845 21.1323 56.1136 21.1323C56.448 21.1323 56.7823 21.1694 57.191 21.2437V16.823C53.8847 16.823 51.47 17.8631 50.1326 19.9435Z",
    fill: "#111312"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2899 27.0761C78.2899 20.8722 74.0548 16.823 68.2596 16.823C62.3529 16.823 58.0064 21.058 58.0064 26.9647C58.0064 32.8714 62.3157 37.1436 68.9654 37.1436C72.3831 37.1436 75.1693 36.0291 76.9525 33.9116L74.4635 31.0511C73.0518 32.4999 71.3058 33.2057 69.0768 33.2057C65.622 33.2057 63.2073 31.3483 62.65 28.4506H78.2156C78.2527 28.0049 78.2899 27.4476 78.2899 27.0761ZM68.2596 20.5379C71.3058 20.5379 73.4976 22.5068 73.8691 25.3673H62.6129C63.0587 22.4696 65.2505 20.5379 68.2596 20.5379Z",
    fill: "#111312"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2279 9.31882V19.4977C94.6676 17.6774 92.4015 16.823 89.8382 16.823C84.0801 16.823 79.8079 20.7979 79.8079 26.9647C79.8079 33.1314 84.0801 37.1436 89.8382 37.1436C92.5501 37.1436 94.8534 36.2148 96.4136 34.3202V36.8835H100.872V9.31882H96.2279ZM90.3955 33.1686C87.052 33.1686 84.4887 30.7539 84.4887 26.9647C84.4887 23.1755 87.052 20.7608 90.3955 20.7608C93.7389 20.7608 96.3022 23.1755 96.3022 26.9647C96.3022 30.7539 93.7389 33.1686 90.3955 33.1686Z",
    fill: "#111312"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.56 17.5595L106.346 17.6836L113.508 23.5147L113.567 23.582C113.77 23.8138 113.923 24.0856 114.016 24.3801L114.044 24.4702L115.385 34.8782L127.56 17.5595ZM106.283 16.6108L106.276 15.5375L127.578 15.4129C127.97 15.4113 128.354 15.5174 128.689 15.7198C129.025 15.9221 129.297 16.2129 129.478 16.5601C129.659 16.9074 129.741 17.2977 129.715 17.6883C129.688 18.0785 129.555 18.4538 129.33 18.7734C129.33 18.7738 129.329 18.7742 129.329 18.7746L117.108 36.1601C117.108 36.1603 117.108 36.1605 117.107 36.1607C116.878 36.487 116.562 36.7424 116.195 36.8981C115.828 37.0538 115.424 37.1034 115.03 37.0412C114.636 36.9789 114.267 36.8074 113.966 36.546C113.664 36.2846 113.442 35.9439 113.325 35.5627L113.298 35.475L111.95 25.0143L104.778 19.1747L104.727 19.1197C104.445 18.8164 104.258 18.4379 104.188 18.0302C104.118 17.6225 104.169 17.2033 104.333 16.8236C104.497 16.4439 104.768 16.1201 105.113 15.8918C105.458 15.6634 105.862 15.5403 106.275 15.5375L106.283 16.6108Z",
    fill: "url(#paint0_linear_32_800)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.838 19.2664L114.523 22.2668C114.592 22.3232 114.657 22.3853 114.716 22.4524L114.775 22.5197C114.775 22.5197 114.775 22.5197 114.775 22.5197C115.127 22.9202 115.391 23.3899 115.551 23.8987L115.579 23.9888C115.607 24.0787 115.627 24.171 115.639 24.2644L116.451 30.5632L124.448 19.1868L110.838 19.2664Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.838 19.2664L114.523 22.2668C114.592 22.3232 114.657 22.3853 114.716 22.4524L114.775 22.5197C114.775 22.5197 114.775 22.5197 114.775 22.5197C115.127 22.9202 115.391 23.3899 115.551 23.8987L115.579 23.9888C115.607 24.0787 115.627 24.171 115.639 24.2644L116.451 30.5632L124.448 19.1868L110.838 19.2664Z",
    fill: "url(#paint1_linear_32_800)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_800",
    x1: 113.036,
    y1: 24.0018,
    x2: 135.556,
    y2: 13.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#B363FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#8FDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_800",
    x1: 112.497,
    y1: 24.7092,
    x2: 133.945,
    y2: 13.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#B363FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FDBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfredBlackSvg);
export default __webpack_public_path__ + "static/media/ALFRED_BLACK_SVG.7ab144517ee476b6626b4bbde5ea8fe0.svg";
export { ForwardRef as ReactComponent };